import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d3cf576"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Co dělám")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Co mě zajímá")
const _hoisted_5 = { class: "ion-padding ion-text-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Přítomný")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Nepřítomný")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Upravit profil ")


import { IonAvatar, IonButton, IonContent, IonItem, IonLabel, IonModal, IonSegment, IonSegmentButton, modalController, SegmentChangeEventDetail } from '@ionic/vue'
import ContentBlocks from '@/components/ContentBlocks.vue'
import TextFormatter from '@/components/TextFormatter.vue'
import { IonSegmentCustomEvent } from '@ionic/core/dist/types/components'

import { EventAttendee } from '@/store/event'
import { useEventStore } from '@/store/event'
import { useAuthStore } from '@/store/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'AttendeeItem',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: EventAttendee
}



const { setAttendee } = useEventStore()
const isAdmin = useAuthStore().claims.isAdmin

async function presentChange (event: IonSegmentCustomEvent<SegmentChangeEventDetail>) {
  const present = event.detail.value === 'true'
  if (props.item.present !== present)
    await setAttendee({ ...props.item, present })
}

async function editItem () {
  const AttendeeForm = await import('@/components/AttendeeForm.vue')
  return (await modalController.create({
    component: AttendeeForm.default,
    componentProps: { itemId: props.item.__id },
    ...AttendeeForm.modalOptions
  })).present()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonItem), {
      id: `performer-${__props.item.__id}-modal`
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonAvatar), { slot: "start" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: __props.item.photoUrl
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonLabel), { class: "person-metadata" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(__props.item.name), 1),
            _createElementVNode("p", null, _toDisplayString(__props.item.about), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id"]),
    _createVNode(_unref(IonModal), {
      trigger: `performer-${__props.item.__id}-modal`,
      "initial-breakpoint": 0.4,
      breakpoints: [0, 0.4, 0.8]
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonContent), { class: "ion-padding-top" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), { class: "ion-padding-bottom" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonAvatar), { slot: "start" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: __props.item.photoUrl
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), { class: "person-metadata" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(__props.item.name), 1),
                    _createElementVNode("p", null, _toDisplayString(__props.item.about), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(TextFormatter, {
                  value: __props.item.doing
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(TextFormatter, {
                  value: __props.item.interests
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(ContentBlocks, {
                  value: __props.item.blocks
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(IonSegment), {
                value: __props.item.present ? 'true' : 'false',
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (presentChange($event))),
                style: {"width":"min-content","margin":"30px auto 0 auto"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegmentButton), { value: "true" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "false" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              (_unref(isAdmin))
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 0,
                    fill: "clear",
                    size: "large",
                    onClick: editItem
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["trigger", "initial-breakpoint", "breakpoints"])
  ], 64))
}
}

})